import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.$style.EmptyList,
    style: _setup.classes
  }, [_c('div', {
    class: _vm.$style.info
  }, [_c('h2', {
    class: _vm.$style.title
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n      "), _c('span', {
    class: _vm.$style.additionalTitle,
    domProps: {
      "innerHTML": _vm._s(_vm.additionalTitle)
    }
  })]), _vm._v(" "), _vm.text ? _c('p', {
    class: [_vm.$style.text, _defineProperty({}, _vm.$style.bottom, !_setup.$slots.action)]
  }, [_vm._v("\n      " + _vm._s(_vm.text) + "\n    ")]) : _vm._e(), _vm._v(" "), _setup.$slots.action ? _c('div', {
    class: _vm.$style.actionWrapper
  }, [_vm._t("action")], 2) : _vm._e()])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };